/* LP Daiane Freitas — motion and plan cycle toggle.
   Shopify: this file goes to assets/lp-daiane.js
   The reveal contract (.scroll-trigger + --animation-order) matches Dawn's,
   so on the theme this block can be dropped and animations.js takes over.
   The hidden state lives behind .js in the CSS, so a script failure leaves
   the page readable rather than blank. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  function revealAll() {
    document.querySelectorAll('.scroll-trigger').forEach(function (el) {
      el.classList.add('is-in');
    });
    document.querySelectorAll('[data-beam]').forEach(function (b) {
      b.classList.add('is-lit');
    });
    var h = document.querySelector('.hero');
    if (h) h.classList.add('is-ready');
  }

  /* If anything below throws, or the observer never fires, the page still
     ends up visible. */
  var safety = window.setTimeout(revealAll, 3000);

  try {

    /* --- hero opening ---------------------------------------------------- */

    var hero = document.querySelector('.hero');

    if (reduced) {
      if (hero) hero.classList.add('is-ready');
    } else {
      window.requestAnimationFrame(function () {
        window.setTimeout(function () {
          if (hero) hero.classList.add('is-ready');
        }, 90);
      });
    }

    /* --- reveal on scroll ---------------------------------------------- */

    var targets = document.querySelectorAll('.scroll-trigger');

    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

      targets.forEach(function (el) { observer.observe(el); });

      var beamObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-lit');
          beamObserver.unobserve(entry.target);
        });
      }, { threshold: 0.6 });

      document.querySelectorAll('.beam').forEach(function (b) {
        beamObserver.observe(b);
      });
    }

    /* --- galeria em arco -------------------------------------------------
       O JS não escreve transform: escreve só a distância de cada foto ao
       centro da tira, com sinal (--t) e em módulo (--a). Quem decide o
       giro, a altura e a escala é o CSS — assim o efeito inteiro cabe numa
       media query de reduced-motion, e sem JS a tira já é legível. */

    var strip = document.querySelector('.gallery__strip');

    if (strip) {
      var cells = Array.prototype.slice.call(strip.querySelectorAll('.gallery__cell'));
      var dotList = [];
      var arcTicking = false;
      var current = -1;

      var how = function () { return reduced ? 'auto' : 'smooth'; };

      /* Uma foto de passo, medida de centro a centro entre duas células
         (largura + gap), em vez de "centralizar a foto i": com padding
         normal a foto 1 já nasce à esquerda do centro, e centralizá-la
         pediria rolagem negativa — o navegador trava e a seta não faz nada. */
      var step = function () {
        var a = cells[0].getBoundingClientRect();
        if (cells.length < 2) return a.width;
        return cells[1].getBoundingClientRect().left - a.left;
      };

      /* O ponto i aponta para uma posição do trecho rolável, não para uma
         foto centrada. É o único mapeamento em que todos os pontos são
         alcançáveis: o primeiro é o começo, o último é o fim. */
      var goToDot = function (i) {
        var max = strip.scrollWidth - strip.clientWidth;
        var last = cells.length - 1;
        strip.scrollTo({
          left: last > 0 ? (i / last) * max : 0,
          behavior: how()
        });
      };

      var nav = null;
      var prev = null;
      var next = null;

      var arrow = function (label, path) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gallery__arrow';
        b.setAttribute('aria-label', label);
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ' +
          'focusable="false"><path d="' + path + '"/></svg>';
        return b;
      };

      if (cells.length > 1) {
        nav = document.createElement('div');
        nav.className = 'gallery__nav';

        prev = arrow('Foto anterior', 'M14.5 5.5 8 12l6.5 6.5');
        next = arrow('Próxima foto', 'M9.5 5.5 16 12l-6.5 6.5');

        var dots = document.createElement('div');
        dots.className = 'gallery__dots';
        dots.setAttribute('role', 'group');
        dots.setAttribute('aria-label', 'Navegar pelas fotos');

        cells.forEach(function (cell, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'gallery__dot';
          dot.setAttribute('aria-label', 'Ir para a foto ' + (i + 1) + ' de ' + cells.length);
          dot.addEventListener('click', function () { goToDot(i); });
          dots.appendChild(dot);
          dotList.push(dot);
        });

        /* aria-disabled em vez de disabled: um botão que fica disabled
           enquanto está focado joga o foco fora da página. Aqui ele
           continua alcançável, só não faz nada. */
        prev.addEventListener('click', function () {
          if (prev.getAttribute('aria-disabled') !== 'true') {
            strip.scrollBy({ left: -step(), behavior: how() });
          }
        });
        next.addEventListener('click', function () {
          if (next.getAttribute('aria-disabled') !== 'true') {
            strip.scrollBy({ left: step(), behavior: how() });
          }
        });

        nav.appendChild(prev);
        nav.appendChild(dots);
        nav.appendChild(next);
        strip.insertAdjacentElement('afterend', nav);
      }

      var arc = function () {
        var box = strip.getBoundingClientRect();
        var mid = box.left + box.width / 2;
        var reach = box.width / 2;

        if (reach > 0) {
          cells.forEach(function (cell) {
            var r = cell.getBoundingClientRect();
            var t = ((r.left + r.width / 2) - mid) / reach;

            /* satura o extremo: além disso a foto já saiu de cena e não
               precisa continuar encolhendo. */
            if (t > 1.35) t = 1.35;
            else if (t < -1.35) t = -1.35;

            if (!reduced) {
              cell.style.setProperty('--t', t.toFixed(3));
              cell.style.setProperty('--a', Math.abs(t).toFixed(3));
            }
          });
        }

        /* O ponto aceso vem da posição no trecho rolável, o mesmo mapa que
           goToDot usa — assim clicar num ponto acende aquele ponto. */
        var maxScroll = strip.scrollWidth - strip.clientWidth;
        var last = cells.length - 1;
        var idx = (maxScroll > 1 && last > 0)
          ? Math.round((strip.scrollLeft / maxScroll) * last)
          : 0;

        /* só escreve no DOM quando o ponto ativo muda de fato */
        if (idx !== current && dotList.length) {
          if (dotList[current]) dotList[current].removeAttribute('aria-current');
          dotList[idx].setAttribute('aria-current', 'true');
          current = idx;
        }

        /* As setas olham a rolagem, não o índice: assim nunca ficam
           desabilitadas com conteúdo ainda por rolar. Só escreve na troca. */
        var flag = function (button, off) {
          if (!button) return;
          var want = String(off);
          if (button.getAttribute('aria-disabled') !== want) {
            button.setAttribute('aria-disabled', want);
          }
        };
        flag(prev, strip.scrollLeft <= 1);
        flag(next, strip.scrollLeft >= maxScroll - 1);

        /* controle que não controla nada é pior que controle nenhum */
        if (nav) nav.hidden = maxScroll <= 1;

        arcTicking = false;
      };

      var queueArc = function () {
        if (arcTicking) return;
        arcTicking = true;
        window.requestAnimationFrame(arc);
      };

      strip.addEventListener('scroll', queueArc, { passive: true });
      window.addEventListener('resize', queueArc, { passive: true });

      /* Uma medida só na carga não basta: enquanto as fotos (lazy) e a
         fonte não assentam, scrollWidth pode vir menor que o real — e aí
         o nav nasceria escondido e ficaria assim. Remede a cada chegada. */
      window.addEventListener('load', queueArc);
      strip.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', queueArc, { once: true });
      });

      arc();
    }

    /* --- weekly / monthly pricing --------------------------------------- */

    var options = Array.prototype.slice.call(document.querySelectorAll('[data-cycle]'));
    var plans = document.querySelectorAll('.plan');
    var status = document.querySelector('[data-cycle-status]');

    var cycles = {
      weekly:  { label: 'por semana', other: 'monthly', otherWord: 'mês', word: 'semanal' },
      monthly: { label: 'por mês',    other: 'weekly',  otherWord: 'semana', word: 'mensal' }
    };

    /* Só o primeiro setCycle é a montagem inicial; ele não deve falar. */
    var announce = false;

    function setCycle(cycle) {
      var spec = cycles[cycle];
      if (!spec) return;

      document.querySelectorAll('.cycle').forEach(function (group) {
        group.classList.toggle('cycle--monthly', cycle === 'monthly');
      });

      options.forEach(function (option) {
        var on = option.getAttribute('data-cycle') === cycle;
        option.setAttribute('aria-checked', String(on));
        option.setAttribute('tabindex', on ? '0' : '-1');
      });

      plans.forEach(function (plan) {
        var shown = plan.getAttribute('data-' + cycle);
        var hidden = plan.getAttribute('data-' + spec.other);

        var price = plan.querySelector('[data-price]');
        var label = plan.querySelector('[data-cycle-label]');
        var equiv = plan.querySelector('[data-equiv]');
        var cta = plan.querySelector('[data-plan-cta]');

        if (price) price.textContent = 'US$ ' + shown;
        if (label) label.textContent = spec.label;
        if (equiv) equiv.textContent = 'US$ ' + hidden + ' se cobrado por ' + spec.otherWord;

        /* The destination has to follow the price. Weekly and monthly are
           different variants in Shopify; leaving the href behind would
           charge the wrong one. */
        if (cta) {
          var url = plan.getAttribute('data-url-' + cycle);
          if (url) cta.setAttribute('href', url);

          var name = plan.getAttribute('data-name');
          if (name) {
            cta.setAttribute('aria-label',
              'Assinar o plano ' + name + ', cobrança ' + spec.word);
          }
        }
      });

      /* Uma frase, não os nove nós de texto que acabaram de mudar. */
      if (status && announce) {
        status.textContent = 'Preços exibidos com cobrança ' + spec.word + '.';
      }
      announce = true;
    }

    options.forEach(function (option, index) {
      option.addEventListener('click', function () {
        setCycle(option.getAttribute('data-cycle'));
      });

      option.addEventListener('keydown', function (event) {
        var next = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          next = options[(index + 1) % options.length];
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          next = options[(index - 1 + options.length) % options.length];
        } else if (event.key === 'Home') {
          next = options[0];
        } else if (event.key === 'End') {
          next = options[options.length - 1];
        }

        if (!next) return;
        event.preventDefault();
        setCycle(next.getAttribute('data-cycle'));
        next.focus();
      });
    });

    if (options.length) setCycle('weekly');

    /* Tudo ligado. Se a rede de segurança continuasse armada ela revelaria
       a página inteira 3s depois do load — e o reveal por rolagem morreria
       sem ninguém perceber. O catch abaixo cobre o caso em que algo falhou. */
    window.clearTimeout(safety);

  } catch (error) {
    window.clearTimeout(safety);
    revealAll();
    if (window.console) console.error('[lp-daiane]', error);
  }

  root.classList.add('lp-ready');
}());
